import PropTypes from 'prop-types';

export const AssetProps = PropTypes.shape({
  id: PropTypes.string,
  type: PropTypes.string,
  name: PropTypes.string,
  org_id: PropTypes.string,
  org_name: PropTypes.string,
  updated_at: PropTypes.string,
  enabled: PropTypes.bool,
  reservable: PropTypes.bool
});

export const AssetDefaults = {
  id: null,
  type: '',
  name: '',
  org_id: null,
  org_name: '',
  updated_at: '',
  enabled: false,
  reservable: false
};

// TODO: Define this; taking a shortcut for now
export const AssetFullProps = {};
